"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.entries");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.object.values");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _postal = _interopRequireDefault(require("@mtt/postal"));

require("./postal-utils");

var _packingSlips = require("./packingSlips");

var _state = require("./state");

var _handlers = require("./handlers");

var _filters = _interopRequireWildcard(require("./filters"));

var _FederationClient = _interopRequireDefault(require("./FederationClient"));

var _queue = _interopRequireDefault(require("./queue"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(0, _queue.default)(_postal.default);
var fedx = _postal.default.fedx = {
  FederationClient: _FederationClient.default,
  packingSlips: _packingSlips.packingSlips,
  handlers: _handlers.handlers,
  clients: _state.state._clients,
  transports: _state.state._transports,
  filters: _filters.default,
  addFilter: _filters.addFilter,
  removeFilter: _filters.removeFilter,
  canSendRemote: function canSendRemote(channel, topic) {
    return (0, _filters.matchesFilter)(channel, topic, "out");
  },
  configure: _state.configure,
  getPackingSlip: _packingSlips.getPackingSlip,
  onFederatedMsg: _handlers.onFederatedMsg,
  sendMessage: function sendMessage(envelope) {
    if (!_state.state._ready) {
      _state.state._outboundQueue.push(arguments);

      return;
    }

    Object.values(this.transports).forEach(function (transport) {
      transport.sendMessage(envelope);
    });
  },
  disconnect: _state.disconnect,
  _getTransports: function _getTransports() {
    return Object.keys(this.transports).reduce(function (memo, name) {
      memo[name] = true;
      return memo;
    }, {});
  },

  /*
  	signalReady( callback );
  	signalReady( "transportName" );
  	signalReady( "transportName", callback );
  	signalReady( "transportName", targetInstance, callback ); <-- this is NEW
  	signalReady( { transportNameA: targetsForA, transportNameB: targetsForB, transportC: true }, callback);
  */
  signalReady: function signalReady(transport, target, callback) {
    var _this = this;

    if (!_state.state._ready) {
      _state.state._signalQueue.push(arguments);

      return;
    }

    var transports = this._getTransports();

    switch (arguments.length) {
      case 1:
        if (typeof transport === "function") {
          callback = transport;
        } else if (typeof transport === "string") {
          transports = {};
          transports[transport] = this.transports[transport];
          callback = _state.NO_OP;
        }

        break;

      case 2:
        if (typeof transport === "string") {
          transports = {};
          transports[transport] = this.transports[transport];
        } else {
          transports = transport;
        }

        callback = target || _state.NO_OP;
        break;

      case 3:
        transports = {};
        transports[transport] = [target];
        break;
    }

    Object.entries(transports).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          targets = _ref2[1];

      targets = typeof targets === "boolean" ? [] : targets;

      _this.transports[name].signalReady(targets, callback);
    });
  }
};
var _default = fedx;
exports.default = _default;

function processSignalQ(args) {
  fedx.signalReady.apply(this, args);
}

function processOutboundQ(args) {
  fedx.send.apply(this, args);
}

function processInboundQ(msg) {
  fedx.onFederatedMsg.call(this, msg);
}

_postal.default.addWireTap(function (data, envelope) {
  if (fedx.canSendRemote(envelope.channel, envelope.topic)) {
    fedx.sendMessage(envelope);
  }
});

_postal.default.subscribe({
  channel: _postal.default.configuration.SYSTEM_CHANNEL,
  topic: "instanceId.changed",
  callback: function callback() {
    _state.state._ready = true;

    while (_state.state._signalQueue.length) {
      processSignalQ(_state.state._signalQueue.shift());
    }

    while (_state.state._outboundQueue.length) {
      processOutboundQ(_state.state._outboundQueue.shift());
    }

    while (_state.state._inboundQueue.length) {
      processInboundQ(_state.state._inboundQueue.shift());
    }
  }
});

if (_postal.default.instanceId() !== undefined) {
  _state.state._ready = true;
}